import React from 'react';
import PropTypes from 'prop-types';
import { FlatList } from 'react-native';

import PrivacyPartnerCard from './PrivacyPartnerCard';
import EmptyPartnerList from './PrivacyEmptyList';
import PrivacyListHeader from './PrivacyListHeader';
import PrivacyListFooter from './PrivacyListFooter';

const PrivacyList = ({
    t,
    block,
    remove,
    unblock,
    listType,
    isLoading,
    isPrivate,
    invertColours,
    addToWhitelist,
    privacyPartnerList,
    openAddPartnerModal,
    openProfile,
}) => (
    <FlatList
        data={privacyPartnerList}
        showsVerticalScrollIndicator={false}
        keyExtractor={item => item.uid}
        contentContainerStyle={{ overflow: 'hidden' }}
        ListHeaderComponent={<PrivacyListHeader
            t={t}
            listType={listType}
            isLoading={isLoading}
            isPrivate={isPrivate}
            privacyPartnerList={privacyPartnerList}
        />}
        ListEmptyComponent={<EmptyPartnerList
            t={t}
            listType={listType}
            isLoading={isLoading}
            invertColours={invertColours}
            privacyPartnerList={privacyPartnerList}
        />}
        ListFooterComponent={<PrivacyListFooter
            t={t}
            listType={listType}
            isPrivate={isPrivate}
            isLoading={isLoading} 
            openAddPartnerModal={openAddPartnerModal}
        />}
        renderItem={({ item, index }) => !isLoading && (
            <PrivacyPartnerCard
                t={t}
                index={index}
                block={block}
                partner={item}
                remove={remove}
                unblock={unblock}
                listType={item.listType}
                isLoading={isLoading}
                isPrivate={isPrivate}
                invertColours={invertColours}
                addToWhitelist={addToWhitelist}
                openProfile={openProfile}
            />
        )}
    />
);

PrivacyList.propTypes = {
    t: PropTypes.func.isRequired,
    block: PropTypes.func,
    remove: PropTypes.func,
    unblock: PropTypes.func,
    invertColours: PropTypes.bool,
    openAddPartnerModal: PropTypes.func,
    isLoading: PropTypes.bool.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    addToWhitelist: PropTypes.func,
    privacyPartnerList: PropTypes.array.isRequired,
    listType: PropTypes.oneOf(['whitelist', 'blacklist', 'searchlist']).isRequired,
};

export default PrivacyList;
